(function () {
  function bindLatest(root) {
    if (root.getAttribute('data-pd26-news-bound') === 'true') return;

    var scroller = root.querySelector('[data-pd26-news-scroller]');
    if (!scroller) return;

    root.setAttribute('data-pd26-news-bound', 'true');

    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;
    var pendingLink = null;
    var blockClick = false;

    function openCard(link) {
      if (!link || !link.href) return;
      if (link.target === '_blank') {
        window.open(link.href, '_blank', 'noopener,noreferrer');
        return;
      }
      window.location.assign(link.href);
    }

    scroller.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    scroller.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      event.preventDefault();
      blockClick = true;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = scroller.scrollLeft;
      pendingLink = event.target.closest('.pd26-news-latest__card');
      scroller.classList.add('is-dragging');
      scroller.setPointerCapture(event.pointerId);
    });

    scroller.addEventListener('pointermove', function (event) {
      if (!dragging) return;

      var delta = event.clientX - startX;
      if (Math.abs(delta) > 4) moved = true;
      scroller.scrollLeft = startScroll - delta;
    });

    function endDrag(event) {
      if (!dragging) return;

      var link = pendingLink;
      var shouldOpen = !moved;
      dragging = false;
      pendingLink = null;
      scroller.classList.remove('is-dragging');
      if (event && event.pointerId != null && scroller.hasPointerCapture(event.pointerId)) {
        scroller.releasePointerCapture(event.pointerId);
      }
      if (shouldOpen) openCard(link);
      window.setTimeout(function () {
        blockClick = false;
        moved = false;
      }, 50);
    }

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', function (event) {
      moved = true;
      endDrag(event);
    });

    scroller.addEventListener('click', function (event) {
      if (!blockClick && !moved) return;
      event.preventDefault();
      event.stopPropagation();
      blockClick = false;
      moved = false;
    }, true);
  }

  function init() {
    document.querySelectorAll('[data-pd26-news-latest]').forEach(bindLatest);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-pd26-news-latest]').forEach(bindLatest);
    if (event.target.hasAttribute('data-pd26-news-latest')) {
      bindLatest(event.target);
    }
  });
})();
